import React from "react";

import { IconProps } from "fe-shared/src/types/common";

const LinkedIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#63696F",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M3.9558 11.38C4.2358 9.91 5.6158 8.9 7.1158 8.9H10.0458C10.5658 8.9 10.9958 8.47 10.9958 7.95C10.9958 7.43 10.5658 7 10.0458 7H7.2158C4.6058 7 2.2758 8.91 2.0258 11.51C1.7358 14.49 4.0758 17 6.9958 17H10.0458C10.5658 17 10.9958 16.57 10.9958 16.05C10.9958 15.53 10.5658 15.1 10.0458 15.1H6.9958C5.0858 15.1 3.5758 13.36 3.9558 11.38ZM8.9958 13H14.9958C15.5458 13 15.9958 12.55 15.9958 12C15.9958 11.45 15.5458 11 14.9958 11H8.9958C8.4458 11 7.9958 11.45 7.9958 12C7.9958 12.55 8.4458 13 8.9958 13ZM13.9458 7H16.7758C19.3858 7 21.7258 8.91 21.9758 11.51C22.2558 14.49 19.9158 17 16.9958 17H13.9458C13.4258 17 12.9958 16.57 12.9958 16.05C12.9958 15.53 13.4258 15.1 13.9458 15.1H16.9958C18.9058 15.1 20.4158 13.36 20.0358 11.38C19.7558 9.91 18.3758 8.9 16.8758 8.9H13.9458C13.4258 8.9 12.9958 8.47 12.9958 7.95C12.9958 7.43 13.4258 7 13.9458 7Z"
    />
  </svg>
);

export default LinkedIcon;
